import { useIsMobile } from '@newfront-insurance/admin-ui';
import { useReducedMotion } from 'framer-motion';
import { useId, type ReactNode } from 'react';

import { CustomGreeting } from './greeting/custom-greeting';
import { NovaEmptyState } from './greeting/nova-empty-state';

interface GreetingProps {
  icon?: ReactNode;
  message?: string;
}

export function Greeting({ message, icon }: GreetingProps) {
  const { isMobile } = useIsMobile();
  const prefersReducedMotion = useReducedMotion() === true;
  const titleId = useId();
  const descriptionId = useId();

  if (icon != null) {
    return (
      <CustomGreeting
        descriptionId={descriptionId}
        icon={icon}
        message={message}
        prefersReducedMotion={prefersReducedMotion}
        titleId={titleId}
      />
    );
  }

  return (
    <NovaEmptyState
      descriptionId={descriptionId}
      isMobile={isMobile}
      message={message}
      prefersReducedMotion={prefersReducedMotion}
      titleId={titleId}
    />
  );
}
